<template>
	<div class="edit-address">
		<div class="title">地址管理</div>

		<div class="input-box">
			<div class="title">地址信息: </div>
			<div style="width:  440px;height: 40px;">
				<Cascader :data="addData" v-model="value"  placeholder="请选择省/市/区/街道"></Cascader>
			</div>

		</div>
		<div class="input-box">
			<div class="title">详细地址:</div>
			<textarea v-model="info.address" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息" />
		</div>
		<div class="input-box">
			<div class="title">邮政编码：</div>
			<input v-model="info.zip_code" placeholder="请输入邮编" />
		</div>
		<div class="input-box">
			<div class="title">收货人姓名：</div>
			<input v-model="info.consignee" placeholder="长度不超过25个字符" />
		</div>
		<div class="input-box">
			<div class="title">手机号码：</div>
			<input v-model="info.mobile" placeholder="请输入手机号码" />
		</div>
		<div class="default">
			<Checkbox v-model="info.is_default"  color="#0F114A">设置为默认收货地址</Checkbox>
		</div>
		<button class="save" @click="save">保存</button>

	</div>
</template>

<script>
	import { getAddress, saveAddress } from "@/api"
	import addData from "../../assets/provinces.js"
	export default {
		name: 'Editaddress',
		components: {

		},
		data() {
			return {
				value: [],
				addData: addData,

				info:{
					address_id: 0,
					consignee: '',
					mobile: '',
					address: '',
					country_name: '中国',
					province_name:'',
					city_name: "",
					zip_code: '',
					is_default: false,
				}
			};
		},
		created() {
			if(this.$route.query.address_id) {
				this.info.address_id = this.$route.query.address_id
				this.get()
			}

		},
		methods: {
			get() {
				getAddress({id: this.info.address_id}).then((res)=>{
					this.info = res.data
					this.info.is_default = this.info.is_default ? true : false
					this.value = [res.data.province_name,res.data.city_name,res.data.zone_name]
				})
			},
			save() {
				this.info.province_name = this.value[0]
				this.info.city_name = this.value[1]
				this.info.zone_name = this.value[2]
				saveAddress(this.info).then((res)=>{
					if(res.code == 0) {
						this.$Notice.success({
							title:  this.info.address_id ? '修改成功' : '添加成功',
						});
						this.$router.back();
					}
				})
			}

		}
	}
</script>

<style lang="scss" scoped>
	.edit-address {
		width: 950px;
		height: 560px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 20px;

		.title {
			font-size: 20px;
			font-weight: bold;
			color: #333333;
			margin-bottom: 20px;
		}

		.input-box {
			margin-bottom: 30px;
			display: flex;

			.title {
				width: 86px;

				font-size: 14px;
				color: #666666;
			}

			input {
				width: 440px;
				height: 40px;
				line-height: 40px;
				background: #FFFFFF;
				border: 1px solid #dcdee2;
				padding-left: 20px;
				color: #333333;
			}

			textarea {
				width: 440px;
				height: 80px;
				border: 1px solid #dcdee2;
				padding-left: 20px;
				padding-top: 10px;
			}
		}

		.save {
			width: 100px;
			height: 40px;
			line-height: 40px;
			background: #0F114A;
			text-align: center;
			font-size: 14px;
			color: #FFFFFF;
			margin-left: 86px;
			padding-bottom: 30px;
		}

		.default {
			margin-left: 86px;
			padding-bottom: 20px;

			.ivu-checkbox-checked .ivu-checkbox-inner {

				border-color: #0F114A !important;
				background-color: #0F114A !important;
			}
		}
	}
</style>
